import { render, staticRenderFns } from "./MaterialDetailDialog.vue?vue&type=template&id=657eafe7"
import script from "./MaterialDetailDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialDetailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports